import React = require('react');

export const PaymentTermsAndConditions = () => {
  return (
    <div className={'terms-container'}>
      <h3>Terms and Conditions</h3>
      <div>Your quotation and our offer of insurance are based on the answers to all the questions we have asked. In
        addition to your Insurance Product Information Document(s) noted above, vou have had access to ‘Your Travel
        Insurance Guide’ within our <a href={'https://www.admiral.com/existing-customers/policy-documents.php'}
                                       target={'_blank'}>Policy Documents</a> section. This section also contains the
        'Your Agreement with EU Limited' document which sets out our services, fees and charges.
      </div>
    </div>
  )
}
